<template>
  <div style="margin-top: 24px">
    <v-simple-table height="655" fixed-header class="table-layout">
      <template v-slot:default>
        <thead>
        <tr>
          <th style="min-width: 150px; max-width: 150px">Người thực hiện</th>
          <th>Nội dung</th>
          <th>Thời gian</th>
        </tr>
        </thead>
        <tbody v-if="items && items.length > 0">
          <tr v-for="(item, index) in items" :key="'note' + index">
            <td class="text-left">{{item.createdBy.fullName}}</td>
            <td class="text-left" v-html="item.description"></td>
            <td class="text-no-wrap text-left"> {{ item.createdAt }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <div style="color: red" class="d-flex align-center justify-center">Không có dữ liệu</div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import ContactRepository from '@/services/ContactRepository';

export default {
  name: 'ActivityTab',
  props: {
    id: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.getListActivity();
  },
  methods: {
    async getListActivity() {
      const params = {
        studentId: this.id,
      };
      const res = await ContactRepository.getListActivity(params);
      if (res.success) {
        this.items = res.data;
      } else {
        this.$swal({
          title: res.message ?? 'Lỗi nhật ký hoạt động xếp lớp!',
          icon: 'error',
          type: 'error',
        });
      }
    },
  },
};
</script>

<style>
.table-layout .v-data-table__wrapper thead th {
  background: #F7F7FC;
  font-size: 14px;
}
.table-layout b {
  font-weight: bold !important;
}
</style>
